import styled from "styled-components";

import {
  actionListSubtitle,
  sectionTitle,
} from "../../../shared/styles/typography";

export { Container, Main } from "../../../styles/adminPage";

export const Fieldset = styled.fieldset`
  border: none;
  padding: 0;
  margin-bottom: 2.4rem;
`;

export const Legend = styled.legend`
  ${sectionTitle}
  margin-bottom: 2rem;
  padding-bottom: 0.8rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  width: 100%;
`;

export const FooterConfig = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.6rem;
  padding-top: 1.6rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin-top: 2.4rem;

  p {
    display: flex;
    align-items: center;
    gap: 1rem;
    ${actionListSubtitle}
    margin: 0;
  }
`;
